import createTheme, {ThemeOptions} from "@mui/material/styles/createTheme";

export const slider: ThemeOptions = createTheme({
	components: {
		MuiIconButton: {
			styleOverrides: {
				colorError: {
					backgroundColor: "var(--primaryColor)",
					color: "#fff",
					"&:hover": {
						backgroundColor: "#831c22",
					},
					"&:disabled": {
						backgroundColor: "var(--primaryColor)",
						color: "#fff",
						opacity: 0.5,
					},
				},
			},
		},
	},
});
